/**
 * What kind of school the organization is; picks the vocabulary preset.
 * Serialized as PascalCase strings.
 */
export enum OrganizationKind {
  Default = "Default",
  Fahrschule = "Fahrschule",
}
